import request from '@/utils/request'


// 查询轮播图列表
export function listBanner(query) {
  return request({
    url: '/banner/banners/list',
    method: 'get',
    params: query
  })
}

// 查询轮播图分页
export function pageBanner(query) {
  return request({
    url: '/banner/banners/page',
    method: 'get',
    params: query
  })
}


export function getDisBill(query) {
  return request({
    url: '/accountBill/accountBills/getDisBill',
    method: 'get',
    params: query
  })
}

export function getChildDisBill(query) {
  return request({
    url: '/accountBill/accountBills/getChildDisBill',
    method: 'get',
    params: query
  })
}
// 查询轮播图详细
export function getBanner(data) {
  return request({
    url: '/banner/banners/detail',
    method: 'get',
    params: data
  })
}

// 新增轮播图
export function addBanner(data) {
  return request({
    url: '/banner/banners/add',
    method: 'post',
    data: data
  })
}

// 修改轮播图
export function updateBanner(data) {
  return request({
    url: '/banner/banners/edit',
    method: 'post',
    data: data
  })
}

// 删除轮播图
export function delBanner(data) {
  return request({
    url: '/banner/banners/delete',
    method: 'post',
    data: data
  })
}
